import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, Badge } from 'reactstrap';
import useSubmittedBidder from '../../../hooks/useSubmittedBidder';
import TenderNotClosedAlert from '../EvaluationOperational/Components/TenderNotClosedAlert';
import {
  displayValue,
  canAccessEvaluationOperationalData,
  getEvaluationOperationalLockReason,
} from '../../../utils/tenderEvaluationHelpers';
import {
  CLARIFICATION_STATUS,
  getClarificationStatusBadge,
} from '../../../../../shared/offer-domain/clarification';

const Clarification = ({
  procurementId,
  procurement,
  isLoadingProcurement = false,
  unreadByMitraId = {},
  isActive = true,
}) => {
  const navigate = useNavigate();
  const canAccessData = canAccessEvaluationOperationalData(procurement);
  const lockReason = getEvaluationOperationalLockReason(procurement);
  const { items, isLoading } = useSubmittedBidder(procurementId, {
    enabled: Boolean(procurementId && canAccessData),
    isActive,
  });

  if (isLoadingProcurement && !procurement) {
    return (
      <div className='text-center py-4'>
        <Spinner size='sm' color='primary' />
        <p className='text-muted mt-2 mb-0 fs-13'>Loading offer data...</p>
      </div>
    );
  }

  if (!canAccessData) {
    return (
      <TenderNotClosedAlert featureLabel='Clarification' reason={lockReason} />
    );
  }

  const handleViewDetail = bidder => {
    const offerId = bidder.idOffer ?? bidder.id;
    if (!procurementId || !offerId) return;
    navigate(
      `/apps-tenderevaluation/dtl/${procurementId}/clarification/${encodeURIComponent(offerId)}`
    );
  };

  if (isLoading) {
    return (
      <div className='text-center py-4'>
        <Spinner size='sm' color='primary' />
        <p className='text-muted mt-2 mb-0 fs-13'>Loading offer data...</p>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className='text-center text-muted py-4 fs-13'>
        Belum ada penawaran yang disubmit.
      </div>
    );
  }

  return (
    <>
      <h5 className='mb-3 fw-semibold'>List of Offering</h5>
      <div className='table-responsive'>
        <Table className='align-middle table-nowrap mb-0'>
          <thead className='table-light'>
            <tr>
              <th className='fs-13'>ID Offer</th>
              <th className='fs-13'>Status Clarification</th>
              <th className='fs-13 text-center'>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map(bidder => {
              const statusBadge = getClarificationStatusBadge(
                bidder.statusClarification,
                bidder.statusClarificationLabel
              );
              const isWaitingPanitia =
                Number(bidder.statusClarification) ===
                  CLARIFICATION_STATUS.WAITING_PANITIA ||
                String(statusBadge.label).toLowerCase() ===
                  'waiting response from panitia tender';
              const hasUnread = Boolean(unreadByMitraId[String(bidder.id)]);
              return (
                <tr
                  key={bidder.id ?? bidder.idOffer}
                  className={
                    isWaitingPanitia
                      ? 'table-warning'
                      : hasUnread
                        ? 'table-info'
                        : undefined
                  }
                >
                  <td
                    className={
                      hasUnread && !isWaitingPanitia
                        ? 'text-info fs-13 fw-semibold'
                        : 'text-dark fs-13'
                    }
                  >
                    {displayValue(bidder.idOffer)}
                  </td>
                  <td className='text-dark fs-13'>
                    <Badge
                      color={statusBadge.color}
                      className='px-2 py-1 fs-11 fw-medium text-nowrap'
                    >
                      {statusBadge.label}
                    </Badge>
                  </td>
                  <td className='text-center'>
                    <button
                      type='button'
                      className='btn btn-soft-primary btn-sm btn-icon'
                      onClick={() => handleViewDetail(bidder)}
                      title='Detail'
                    >
                      <i className='ri-eye-line align-bottom'></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default Clarification;
